import { useTranslation } from "react-i18next";
import { classNames } from "../../helpers";

type UserTypeBadgeProps = {
  userType: string;
};
export default function UserTypeBadge(props: UserTypeBadgeProps) {
  const { t } = useTranslation("", {
    keyPrefix: "userType",
  });
  let { userType } = props;
  if (userType === "candidate") userType = "student";

  return (
    <span
      className={classNames(
        "inline-flex items-center h-fit rounded-full py-1 px-2 text-xs font-normal whitespace-nowrap",
        userType === "student" && "bg-brandblue-100 text-brandblue-700",
        userType === "tutor" && "bg-indigo-100 text-indigo-700",
        (userType === "liaison" || userType === "supervisor") &&
          "bg-green-50 text-green-500"
      )}
    >
      {t(userType)}
    </span>
  );
}
